<div class="module-header">
  <h4 class="module-header-title">{{ title() }}</h4>

  <div class="module-header-indicators">
    <ima-conflict-indicator
      [label]="i18n.t('moduleHeader.reportedConflicts')"
      [count]="reportedConflictsCount()"
      color="gray"
      [disabled]="true"
    />

    <span class="module-header-indicators-divider"></span>

    <ima-conflict-indicator
      [label]="i18n.t('moduleHeader.criticalStock')"
      [count]="criticalStockCount()"
      color="purple"
    />
  </div>
</div>
